import React from "react";
import { StyledPageHeader } from "./style";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import menuList from "../../constants/menuList";
import userTypes from "../../constants/userTypes";

const PageHeader = ({
  title,
  inline = false,
  inlineRoute = "",
  icon,
  children,
  useMenuTitle = true,
}) =>
{
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const authUser = useSelector((state) => state.auth?.user);
  const roleName = useSelector((state) => state.auth?.role?.name);
  const normalizedRole = String(roleName || authUser?.userType || "").toUpperCase();

  const roleKey =
    normalizedRole === userTypes.DOCTOR ? "doctor" :
    normalizedRole === userTypes.EMPLOYEE ? "employee" :
    normalizedRole === userTypes.ASSISTANT ? "assistant" :
    normalizedRole === userTypes.PATIENT ? "patient" :
    null;

  const firstPathSegment = location.pathname.replace(/^\/+/, "").split("/")[0];
  const menuTitle = React.useMemo(() => {
    if (!useMenuTitle || !roleKey || !firstPathSegment) return "";
    const menuItem = (menuList[roleKey] || []).find((item) => {
      const targetPath = String(item?.to || "").replace(/^\/+/, "");
      return targetPath && targetPath === firstPathSegment;
    });
    return menuItem?.text ? t(menuItem.text) : "";
  }, [useMenuTitle, roleKey, firstPathSegment, t]);
  /** İçerik alanı: sidebar’daki seçilen menü öğesi adı öncelikli; menü eşleşmezse `title` kullanılır. */
  const resolvedTitle = useMenuTitle
    ? (menuTitle || title || "")
    : (title || "");

  const handleBack = () =>
  {
    // window.history.back();
    navigate(inlineRoute, { replace: true});
  };
  return (
    <StyledPageHeader>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25, minWidth: 240 }}>
        <Typography sx={{ display: "flex", alignItems: "center" }} variant="h1" fontSize="1.2rem">
          {inline && (
            <IconButton onClick={handleBack}>
              <ArrowBackIcon />
            </IconButton>
          )}
          {icon && (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", paddingRight: 1, paddingLeft: 1 }}>
              {icon}
            </Box>
          )}
          {resolvedTitle}
        </Typography>
      </Box>
      {children}
    </StyledPageHeader>
  );
};

export default PageHeader;
